<template>
    <div class="channel-picker" :class="{ disabled }">
        <a-popover placement="rightTop" overlayClassName="channel-picker-popover" :visible="visible">
            <template #content>
                <div class="picker-content">
                    <div class="header">{{ $t("message.channelFilter") }}</div>
                    <div class="search-wrapper">
                        <a-input-search v-model:value="search" :placeholder="$t('message.searchChannel')" />
                    </div>
                    <div class="btnGroup">
                        <SupsisButton
                            :classNames="mode === 'active' ? 'btnGroupItem selected' : 'btnGroupItem '"
                            :primary="mode === 'active'"
                            :ghost="mode !== 'active'"
                            @click="() => changeMode('active')"
                            small
                        >
                            {{ $t("message.activeChannels") }}
                        </SupsisButton>
                        <SupsisButton
                            :classNames="mode === 'deleted' ? 'btnGroupItem selected' : 'btnGroupItem '"
                            :primary="mode === 'deleted'"
                            :ghost="mode !== 'deleted'"
                            @click="() => changeMode('deleted')"
                            small
                        >
                            {{ $t("message.deleteChannels") }}
                        </SupsisButton>
                    </div>

                    <div class="groups">
                        <div class="list-item" v-if="showAllOption" @click="change(allOptionValue)">
                            <span>{{ allOptionLabel }}</span>
                        </div>
                        <div class="group-title" v-if="getFilteredChannels('whatsapp-business-api', 'whatsapp-business-api-supsis').length">
                            Whatsapp Business API
                        </div>
                        <div
                            class="list-item"
                            v-for="channel in getFilteredChannels('whatsapp-business-api', 'whatsapp-business-api-supsis')"
                            :key="channel._id"
                            @click="change(channel._id)"
                        >
                            <span>{{ channel.name }}</span>
                        </div>
                        <!--                        <div class="group-title" v-if="getFilteredChannels('whatsapp-qr').length">-->
                        <!--                            Whatsapp V1 Channels-->
                        <!--                        </div>-->
                        <!--                        <div-->
                        <!--                            class="list-item"-->
                        <!--                            v-for="channel in getFilteredChannels('whatsapp-qr')"-->
                        <!--                            @click="change(channel._id)"-->
                        <!--                        >-->
                        <!--                            <span>{{ channel.name }}</span>-->
                        <!--                        </div>-->
                        <div class="group-title" v-if="getFilteredChannels('whatsapp-v2').length">
                            Whatsapp V2 Channels
                        </div>
                        <div
                            class="list-item"
                            v-for="channel in getFilteredChannels('whatsapp-v2')"
                            :key="channel._id"
                            @click="change(channel._id)"
                        >
                            <span>{{ channel.name }}</span>
                        </div>

                        <div class="group-title" v-if="getFilteredChannels('whatsapp-unipile').length">
                            Whatsapp V3 Channels
                        </div>
                        <div
                            class="list-item"
                            v-for="channel in getFilteredChannels('whatsapp-unipile')"
                            :key="channel._id"
                            @click="change(channel._id)"
                        >
                            <span>{{ channel.name }}</span>
                        </div>

                        <div class="group-title" v-if="getFilteredChannels('instagram').length">Instagram</div>
                        <div
                            class="list-item"
                            v-for="channel in getFilteredChannels('instagram','instagram-v2')"
                            :key="channel._id"
                            @click="change(channel._id)"
                        >
                            <span>{{ channel.name }}</span>
                        </div>
                        <div class="group-title" v-if="getFilteredChannels('messenger').length">Messenger</div>
                        <div
                            class="list-item"
                            v-for="channel in getFilteredChannels('messenger')"
                            :key="channel._id"
                            @click="change(channel._id)"
                        >
                            <span>{{ channel.name }}</span>
                        </div>

                        <div class="group-title" v-if="getFilteredChannels('telegram-unipile').length">Telegram</div>
                        <div
                            class="list-item"
                            v-for="channel in getFilteredChannels('telegram-unipile')"
                            :key="channel._id"
                            @click="change(channel._id)"
                        >
                            <span>{{ channel.name }}</span>
                        </div>

                        <div class="group-title" v-if="getFilteredChannels('linkedin-unipile').length">Linkedin</div>
                        <div
                            class="list-item"
                            v-for="channel in getFilteredChannels('linkedin-unipile')"
                            :key="channel._id"
                            @click="change(channel._id)"
                        >
                            <span>{{ channel.name }}</span>
                        </div>

                        <div class="group-title" v-if="getFilteredChannels('trendyol').length">Trendyol</div>
                        <div
                            class="list-item"
                            v-for="channel in getFilteredChannels('trendyol')"
                            :key="channel._id"
                            @click="change(channel._id)"
                        >
                            <span>{{ channel.name }}</span>
                        </div>
                    </div>
                </div>
            </template>
            <SupsisButton ghost @click="() => (visible = !visible)" :disabled="disabled">
                <i class="material-icons">filter_list</i>

                <span>{{ getSelectedChannelName() }}</span>

                <i class="material-icons" v-if="!visible">arrow_drop_down</i>
                <i class="material-icons" v-else>arrow_drop_up</i>
            </SupsisButton>
        </a-popover>
    </div>
</template>
<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import { CHANNEL_API } from "../../api/channel";
import _ from "lodash";
import SupsisButton from "../../views/Pages/Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "ChannelPicker",
    components: {
        SupsisButton,
    },
    props: {
        value: {
            //string or array
            type: String,
        },
        includeDeleted: {
            type: Boolean,
            default: false,
        },
        autoSelectFirst: {
            type: Boolean,
            default: true,
        },
        allowedTypes: {
            type: Array,
            default: () => ["whatsapp-qr", "whatsapp-v2", "whatsapp-unipile", "whatsapp-business-api", "whatsapp-business-api-supsis"],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        showAllOption: {
            type: Boolean,
            default: false,
        },
        allOptionLabel: {
            type: String,
            default: "All Channels",
        },
        allOptionValue: {
            type: String,
            default: "all",
        },
    },
    data() {
        return {
            search: "",
            clone: this.value,
            channels: [],
            visible: false,
            mode: "active",
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            users: (state) => state.user.users.data,
        }),
        ...mapGetters({}),
    },
    methods: {
        changeMode(mode) {
            this.mode = mode;
        },
        fetchChannels() {
            CHANNEL_API.listChannels(this.includeDeleted).then((response) => {
                this.channels = response.data.filter((channel) => this.allowedTypes.includes(channel.type));
                this.channels = _.orderBy(this.channels, ["isDeleted", "name"], ["asc", "asc"]);
                if (this.autoSelectFirst && !!this.value) {
                    this.clone = this.channels[0]?._id;
                }
            });
        },
        change(id) {
            this.clone = id;
            this.visible = false;
        },
        getFilteredChannels(...types) {
            const q = (this.search || "").trim().toLowerCase();
            if (q.length === "") {
                return this.channels.filter((channel) => types.includes(channel.type));
            }
            let filteredChannels = this.channels.filter(
                (channel) => channel.name.toLowerCase().includes(q) && types.includes(channel.type)
            );
            if (this.mode === "active") {
                filteredChannels = filteredChannels.filter((channel) => !channel.isDeleted);
            } else if (this.mode === "deleted") {
                filteredChannels = filteredChannels.filter((channel) => channel.isDeleted);
            }
            return filteredChannels;
        },
        getSelectedChannelName() {
            if (this.clone === this.allOptionValue) {
                return this.allOptionLabel;
            }
            return (
                this.channels.find((channel) => channel._id === this.clone)?.name || this.$t("message.selectChannel")
            );
        },
    },
    mounted() {
        this.fetchChannels();
    },
    watch: {
        value(val) {
            if (val !== this.clone) {
                this.clone = val;
            }
        },
        clone(val) {
            this.$emit("input", val);
        },
    },
});
</script>

<style lang="scss">
.channel-picker-popover {
    &.disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    .ant-popover-inner-content {
        padding: 0 !important;
        box-shadow: var(--shadow-dropdown-400);
        border: 1px solid var(--color-border-default);
        border-radius: 5px;
    }

    .picker-content {
        display: flex;
        flex-direction: column;
        gap: 3px;
        width: 300px;

        .btnGroup {
            display: flex;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
            margin: 2px 10px;
            padding: 2px;

            .btnGrupItem {
                &.selected {
                    background: var(--color-bg-oncomponent-default);
                    box-shadow: var(--shadow-interaction-200);
                }
            }

            .supsis-button {
                border: none !important;
                font-size: 13px;
                height: 25px;
            }
        }

        .header {
            display: flex;
            flex-flow: column;
            color: var(--color-text-strong-default);
            background-color: var(--color-bg-neutral-low-default);
            outline-style: none;
            cursor: default;
            justify-content: center;
            align-items: center;
            padding: 8px;
            width: 100%;
        }

        .search-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 8px 20px;
        }

        .groups {
            display: flex;
            flex-direction: column;
            max-height: 600px;
            min-height: 300px;
            overflow-y: auto;
        }

        .group-title {
            display: flex;
            flex-flow: column;
            color: var(--color-text-strong-default);
            background-color: var(--color-bg-neutral-low-default);
            outline-style: none;
            cursor: default;

            font-weight: 600;
            justify-content: left;
            text-align: left;
            text-transform: uppercase;
            padding: 8px 12px;
            font-size: 12px;
        }

        .list-item {
            display: flex;
            position: relative;
            padding: 8px 12px;
            cursor: pointer;
            transition: background-color 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
            overflow-wrap: anywhere;
            background-color: var(--color-bg-default);
            font-size: 14px;
            font-weight: 500;
            color: var(--color-text-strong-default);
            align-items: center;
            gap: 5px;
            border-bottom: 1px solid var(--color-border-default);

            &:hover {
                background: var(--color-bg-hover);
            }
        }
    }
}

.channel-picker {
    display: flex;
    flex-direction: column;
}
</style>
